import { useQuery } from '@tanstack/react-query';
import { userApi } from '../api/userApi';

/**
 * GET /api/eraf/users/{id} — 사용자 상세 조회
 * queryKey: ['user-management', 'detail', id]
 */
export function useUserDetail(id: number | undefined) {
  return useQuery({
    queryKey: ['user-management', 'detail', id],
    queryFn: () => userApi.get(id!),
    enabled: id !== undefined && id > 0,
    staleTime: 30_000,
  });
}
